module.exports = __webpack_public_path__ + "img/S-WEB-Goal-04.779aecb5.png";